import Head from 'next/head';

/**
 * ViewPortHead ensures a single, consistent viewport meta tag is present for responsive design.
 * Include this component in _app.tsx for every app.
 */
export const ViewPortHead = () => (
  <Head>
    <meta name="viewport" content="width=device-width, initial-scale=1" />
  </Head>
);

ViewPortHead.displayName = 'ViewPortHead';
